/**
 * Accessible Tabs Component
 * Tab panels are directly clickable (similar to map locations)
 * with keyboard navigation support
 */
document.addEventListener( 'DOMContentLoaded', () => {
	const tabsBlocks = /** @type {HTMLElement[]} */ ( Array.from( document.querySelectorAll( '.wp-block-wdg-tabs' ) ) );

	tabsBlocks.forEach( ( block ) => {
		initializeTabs( block );
	} );

	/**
	 * Initialize a tabs block with accessibility features
	 *
	 * @param {HTMLElement} block
	 */
	function initializeTabs( block ) {
		const tabPanels = /** @type {HTMLElement[]} */ ( Array.from( block.querySelectorAll( '.wp-block-wdg-tab' ) ) );

		if ( ! tabPanels.length ) {
			return;
		}

		// Set up each tab panel
		tabPanels.forEach( ( panel, index ) => {
			// Make linked tabs focusable and clickable
			if ( panel.dataset.linkUrl ) {
				// Make panels focusable and add keyboard support
				panel.setAttribute( 'tabindex', '0' );

				// Add click handler
				panel.addEventListener( 'click', () => {
					// activateTab( tabPanels, index );

					// Handle link navigation if URL is provided
					const linkUrl = panel.dataset.linkUrl;
					const linkTarget = panel.dataset.linkTarget || '_self';
					if ( linkUrl ) {
						if ( linkTarget === '_blank' ) {
							window.open( linkUrl, '_blank', 'noopener,noreferrer' );
						} else {
							window.location.href = linkUrl;
						}
					}
				} );

				// Add keyboard handlers for accessibility
				panel.addEventListener( 'keydown', ( e ) => {
					handlePanelKeydown( e, tabPanels, index );
				} );
			}
		} );
	}

	/**
	 * Activate a specific tab
	 *
	 * @param {HTMLElement[]} panels
	 * @param {number}        index
	 */
	function activateTab( panels, index ) {
		// Show active panel, hide others
		panels.forEach( ( panel, i ) => {
			const isActive = i === index;
			panel.setAttribute( 'aria-hidden', isActive ? 'false' : 'true' );
		} );
	}

	/**
	 * Handle keyboard navigation on tab panels
	 * Supports: Arrow keys, Home, End, Enter, Space
	 *
	 * @param {KeyboardEvent} e
	 * @param {HTMLElement[]} panels
	 * @param {number}        currentIndex
	 */
	function handlePanelKeydown( e, panels, currentIndex ) {
		let targetIndex = currentIndex;

		switch ( e.key ) {
			// case 'ArrowUp':
			// 	e.preventDefault();
			// 	targetIndex = currentIndex > 0 ? currentIndex - 1 : panels.length - 1;
			// 	break;

			// case 'ArrowDown':
			// 	e.preventDefault();
			// 	targetIndex = currentIndex < panels.length - 1 ? currentIndex + 1 : 0;
			// 	break;

			// case 'Home':
			// 	e.preventDefault();
			// 	targetIndex = 0;
			// 	break;

			// case 'End':
			// 	e.preventDefault();
			// 	targetIndex = panels.length - 1;
			// 	break;

			case 'Enter':
			case ' ':
				// Space and Enter activate the tab and follow link if present
				e.preventDefault();
				activateTab( panels, currentIndex );

				const panel = panels[ currentIndex ];
				const linkUrl = panel.dataset.linkUrl;
				const linkTarget = panel.dataset.linkTarget || '_self';

				if ( linkUrl ) {
					if ( linkTarget === '_blank' ) {
						window.open( linkUrl, '_blank', 'noopener,noreferrer' );
					} else {
						window.location.href = linkUrl;
					}
				}
				return;

			default:
				return;
		}

		// // Activate the target tab and move focus
		// if ( targetIndex !== currentIndex ) {
		// 	activateTab( panels, targetIndex );
		// 	panels[ targetIndex ].focus();
		// }
	}
} );

